import { useContext, useState } from 'react';
import { AdminFormModal, ModalStage } from '../../../AdminFormModal';
import { Alert } from '@platform/components';
import { AdminTeams } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { AdminTableContext } from '../../../AdminTable';

export const DeleteTeamModal = ({
  teamId,
  cohortId,
  onClose,
}: {
  teamId: number;
  cohortId: number;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const deleteTeamMutator = AdminTeams.useDeleteTeam({
    mutation: {
      onMutate: () => {
        setModalStage('submitting');
      },
      onSuccess: () => {
        setModalStage('success');
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetFreeAgentsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsCountsQueryKey({
            cohort_id: cohortId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamIdsQueryKey({ cohort_id: cohortId }),
        });
      },
      onError: () => {
        setModalStage('error');
      },
    },
  });
  return (
    <AdminFormModal
      title={`Delete Team #${teamId}?`}
      modalStage={modalStage}
      onClose={onClose}
      submitCTA={{
        text: 'Delete team',
        callback: () => {
          deleteTeamMutator.mutate({ params: { team_id: teamId } });
        },
      }}
    >
      <Alert variant='warning'>All associated match records will be deleted</Alert>
    </AdminFormModal>
  );
};
